import React from "react";
import StaffPerformanceSection from "./StaffPerformanceSection";

const TeamPerformanceReport = ({ staffPerformance, monthLabel, programType, mpcCopy, onTeamMemberMonthClick }) => {
  const currentMonthLabel = staffPerformance?.currentMonth?.label || monthLabel;
  const previousMonthLabel = staffPerformance?.previousMonth?.label || "Previous month";
  const priorThreeMonths = staffPerformance?.priorThreeMonths || [];
  const priorMonthsListLabel = priorThreeMonths
    .map((month) => month?.label)
    .filter(Boolean)
    .join(" · ");

  return (
    <div className="mpc-report-panel mpc-report-panel--team" role="tabpanel" id="mpc-report-panel-teamPerformance">
      <StaffPerformanceSection
        staffPerformance={staffPerformance}
        programType={programType}
        mpcCopy={mpcCopy}
        embedded
        onTeamMemberMonthClick={onTeamMemberMonthClick}
      />

      <div className="mpc-help-card mpc-team-help-card">
        <h6>
          <i className="mdi mdi-book-open-variant" />
          How to Read This Report
        </h6>
        <div className="mpc-help-grid mpc-team-help-grid">
          <div className="mpc-help-item">
            <span className="mpc-help-label">What is counted</span>
            <strong>
              Every number on this report is a <em>documented consultation note</em> count — how many{" "}
              <em>{mpcCopy.consultationTitle}</em> notes were saved that month. It is <strong>not</strong> a count of
              unique patients.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">In one sentence</span>
            <strong>
              This report shows how many documented <em>{mpcCopy.consultationTitle}</em> notes each person on your
              team completed — and whether that note count is up or down compared to recent months.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">{currentMonthLabel}</span>
            <strong>
              Consultation notes documented during the selected month (<em>{currentMonthLabel}</em>).
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">{previousMonthLabel}</span>
            <strong>
              Consultation notes documented during the previous month (<em>{previousMonthLabel}</em>) — use this to see if
              note volume went up or down.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">{mpcCopy.teamTrend}</span>
            <strong>
              <span className="mpc-help-tag met">↑ More</span> or{" "}
              <span className="mpc-help-tag not-met">↓ Fewer</span> consultation notes compared to{" "}
              <em>{previousMonthLabel}</em>.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">{mpcCopy.teamUsualPace}</span>
            <strong>
              {mpcCopy.teamUsualPaceHint}
              {priorMonthsListLabel ? (
                <>
                  {" "}
                  Based on <em>{priorMonthsListLabel}</em>.
                </>
              ) : null}{" "}
              Shown as <em>{mpcCopy.teamAverageFormula}</em> in the calculation panel and under each team
              member&apos;s &quot;Usual Pace&quot; column. Result is consultation notes per month, not patients.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">Patient drill-down</span>
            <strong>
              Click any month note count in the table to open a searchable patient list with consultation details for that
              team member in that month.
            </strong>
          </div>
          <div className="mpc-help-item">
            <span className="mpc-help-label">Client requirement</span>
            <strong>
              List staff/providers with current-month consultation note counts, compare to the previous month, and show a
              3-month average note count based on the three months before the selected month.
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPerformanceReport;
